import { Tab, Tabs } from '@material-ui/core';
import CSS from 'csstype';
import { orderBy } from 'lodash-es';
import React from 'react';

import { ISimpleTab } from '~/src/dash/components/tabs/common';
import { Div, usePanel } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

interface ISimpleTabsProps {
  activeTabIndex: number;
  ariaLabel: string;
  handleChangeTab: (_event: React.SyntheticEvent, newValue: number) => void;
  indicatorColor?: string;
  indicatorStyle?: CSS.Properties;
  tabs: ISimpleTab[];
  tabsStyle?: CSS.Properties;
  tabStyle?: CSS.Properties;
  wrapperStyle?: CSS.Properties;
}

// use this in conjunction with SimpleTabSections
export const SimpleTabs = ({
  activeTabIndex,
  ariaLabel,
  handleChangeTab,
  indicatorColor,
  indicatorStyle = {},
  tabs,
  tabsStyle = {},
  tabStyle = {},
  wrapperStyle = {},
}: ISimpleTabsProps) => {
  const { theme } = usePanel();
  const tabActiveColor = indicatorColor || theme.primaryButton || publicaColors.blue;

  return (
    <Div
      style={{
        borderBottom: `1px solid ${publicaColors.lightGray}`,
        ...wrapperStyle,
      }}
    >
      <Tabs
        value={activeTabIndex}
        onChange={handleChangeTab}
        variant='scrollable'
        aria-label={`${ariaLabel} Tabs`}
        style={{
          padding: '0px',
          ...tabsStyle,
        }}
        TabIndicatorProps={{
          style: {
            color: tabActiveColor,
            backgroundColor: tabActiveColor,
            ...indicatorStyle,
          },
        }}
      >
        {orderBy(tabs, 'value').map((tab, i) => {
          return (
            <Tab
              label={tab.label}
              {...a11yProps(i)}
              style={{
                color: activeTabIndex === i ? tabActiveColor : 'inherit',
                ...tabStyle,
              }}
            />
          );
        })}
      </Tabs>
    </Div>
  );
};
